var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"mt-5 text-center"},[_c('font-awesome-icon',{attrs:{"icon":"spinner","color":"#E8E7E7","spin":"","size":"6x"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }